import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../../../redux/issuesV2';
import type { LicensingIssue } from '../../../../../../shared/issuesV2';

import { GlobalLicensesTable } from './GlobalLicensesTable';
import { ProjectLicensesTable } from './ProjectLicensesTable';
import { ReleaseGroupLicensesTable } from './ReleaseGroupLicensesTable';
import { IssueScopeKind } from '../../../../../../shared/issuesV2/common';

export const IssueDetailsLicensesTable: VoidFunctionComponent = () => {
  const scope = useSelector(IssuesV2Store.selectors.getScope);
  // This component is only used for licensing issues, so we can safely cast the issue details to a LicensingIssue.
  const activeIssue = useSelector(IssuesV2Store.selectors.getIssueDetails) as LicensingIssue;

  const dependencyRevisionLocator = activeIssue?.source.id;

  if (!dependencyRevisionLocator) {
    return null;
  }

  if (scope.type === IssueScopeKind.ReleaseGroup) {
    return (
      <ReleaseGroupLicensesTable
        dependencyRevisionLocator={dependencyRevisionLocator}
        releaseGroupId={Number(scope.id)}
        releaseId={scope.release}
      />
    );
  }

  if (scope.type === IssueScopeKind.Project) {
    return (
      <ProjectLicensesTable
        dependencyRevisionLocator={dependencyRevisionLocator}
        projectId={scope.id}
        revisionId={scope.revision as string}
      />
    );
  }

  return <GlobalLicensesTable dependencyRevisionLocator={dependencyRevisionLocator} />;
};
